<template>
  <v-form @submit.prevent="submit">
    <v-card>
      <v-card-title>{{ $t('Your demo account expires in') }} {{ demoExpiresDays }} {{ $t('days') }}</v-card-title>
      <v-card-text>
        <p class="body-1">
          {{ $t('Fill out this form to convert your demo account to a real account and save your created FAQs.') }}
        </p>
        <v-text-field
          v-model="form.email"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.email"
          :label="$t('Email')"
          outlined
          name="email"
          type="email"
          autocomplete="email"
        />

        <v-text-field
          v-model="form.name"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.name"
          :label="$t('Name')"
          outlined
          name="name"
          autocomplete="name"
        />

        <password-input
          v-model="form.password"
          outlined
          :label="$t('Password')"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.password"
        />

        <v-text-field
          v-model="form.password_confirmation"
          :loading="form.processing"
          :disabled="form.processing"
          autocomplete="off"
          :label="$t('Confirm password')"
          outlined
          type="password"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          :loading="form.processing"
          :disabled="form.processing"
          color="primary"
        >
          {{ $t('Convert account') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import PasswordInput from '../../components/shared/PasswordInput.vue';

export default {
  components: {
    PasswordInput
  },

  props: {
    demoExpiresDays: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      showPassword: false,
      showPasswordTooltip: false,
      form: this.$inertia.form({
        email: '',
        name: '',
        country: '',
        password: '',
        password_confirmation: ''
      })
    }
  },

  methods: {
    submit() {
      this.form.patch(this.route('demo.convert'));
    },
  }
}
</script>